var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"text-center w-full py-5"},[_c('span',[_c('fa-icon',{attrs:{"icon":"fa-regular fa-copyright"}}),_vm._v(" "+_vm._s(new Date().getFullYear())+" Whilmer Realigue. All Rights Reserved. ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }